import React, { Component } from 'react';
import * as color from '../colors';
import Styled from 'styled-components';
import SideBar from './../common/sideBar';
import ServiceListItem from './../common/serviceListItem';
import dog from '../../assets/images/thumbnail/dog.jpg';

const Section = Styled.section`
height: 100vh;
overflow:hidden;
display:grid;
grid-template-columns: max-content 35% 1fr;
`;

const MyServices = Styled.div`
background-color: ${color.tertiary};
`;

const MyServicesSectionWrapper = Styled.div`
display: grid;
grid-template-rows: 50vh 50vh;
`;

const MyServicesSection = Styled.div`
display:block;
overflow-Y: auto;
height:90%;
`;

const MyServicesScroll = Styled.div`
height:100%;
`;

const MyServicesIntro = Styled.h3`
display:block;
text-transform: uppercase;
background-color:${color.primaryAlt};
font-size: 1.3rem;
color: ${color.white};
width: 100%;
font-weight: 100;
padding: 1rem 5rem;
`;

class Dashboard extends Component {
  state = {
    services: {
      completed: [
        {
          id: 1,
          type: 'Dog walk',
          times: ['Morning'],
          date: 'Friday February, 19th',
        },
        {
          id: 2,
          type: 'Dog walk',
          times: ['Morning'],
          date: 'Thursday February, 18th',
        },
        {
          id: 3,
          type: 'Dog walk',
          times: ['Morning'],
          date: 'Wednesday February, 17th',
        },
      ],
      scheduled: [
        {
          id: 1,
          type: 'Dog walk',
          times: ['Morning'],
          date: 'Friday February, 19th',
        },
        {
          id: 2,
          type: 'Dog walk',
          times: ['Morning'],
          date: 'Sunday February, 21th',
        },
      ],
    },
  };
  render() {
    const { scheduled, completed } = this.state.services;
    return (
      <Section>
        <SideBar
          button
          lists={[
            {
              intro: 'profile',
              links: [
                { label: 'Scheduled', path: '/address' },
                { label: 'Completed', path: '/contact' },
              ],
            },
            {
              intro: 'payment info',
              links: [
                { label: 'Ginger', path: '/pets/ginger' },
                { label: 'Fluffy', path: '/pets/fluffy' },
              ],
            },
          ]}
          links={[
            { label: 'My account', path: '/account' },
            { label: 'Support', path: '/support' },
            { label: 'Sign out', path: '/sign-out' },
          ]}
        />
        <MyServices>
          <MyServicesSectionWrapper>
            <MyServicesScroll>
              <MyServicesIntro>Scheduled</MyServicesIntro>
              <MyServicesSection>
                {scheduled.map((s) => (
                  <ServiceListItem
                    type={s.type}
                    times={s.times}
                    date={s.date}
                  />
                ))}
              </MyServicesSection>
            </MyServicesScroll>

            <MyServicesScroll>
              <MyServicesIntro>Completed</MyServicesIntro>
              <MyServicesSection>
                {completed.map((c) => (
                  <ServiceListItem
                    type={c.type}
                    times={c.times}
                    date={c.date}
                    image={dog}
                  />
                ))}
              </MyServicesSection>
            </MyServicesScroll>
          </MyServicesSectionWrapper>
        </MyServices>
      </Section>
    );
  }
}

export default Dashboard;
